import { createSelector } from '@ngrx/store'
import { AppState } from '../storage.module'
import { StageState } from './stage.reducer'

export const getStage = (state: AppState) => state.stage

export const selectMenuOpen = createSelector(getStage, (state: StageState) => state.isMenuOpen)

export const selectBreadcrumbs = createSelector(getStage, (state: StageState) => state.breadcrumbs)

export const selectSearchData = createSelector(getStage, (state: StageState) => state.searchData)

export const selectPrefilterData = createSelector(getStage, (state: StageState) => state.prefilterData)

export const selectIsPrivacyStatementAccepted = createSelector(getStage, (state: StageState) => state.isPrivacyStatementAccepted)

export const selectUser = createSelector(getStage, (state: StageState) => state.user)

export const innplaceList = createSelector(getStage, (state: StageState) => state.innplaceList)
